import { z } from '@kc3/validation';
export const OnDemandRecordingStartEventSchema = z.object({
    tenantSlug: z.string(),
    callId: z.string().uuid().or(z.string().length(0)),
    bridgeId: z.string().or(z.string().length(0)),
    channelId: z.string().or(z.string().length(0)),
    agentId: z.string().uuid(),
    timestamp: z.string().datetime(),
});
export const OnDemandRecordingStopEventSchema = z.object({
    tenantSlug: z.string(),
    callId: z.string().uuid().or(z.string().length(0)),
    channelId: z.string().or(z.string().length(0)),
    recordingName: z.string().or(z.string().length(0)),
    agentId: z.string().uuid(),
    timestamp: z.string().datetime(),
});
//# sourceMappingURL=on-demand-recording.js.map